import { defineMessages } from 'react-intl'

export const JobInfoImagesMessages = defineMessages({
  title: {
    id: 'JobInfoImagesMessages.title',
    description: 'Title for Images block on JobInfo page',
    defaultMessage: 'Images',
  },
  uploadButtonLabel: {
    id: 'JobInfoImagesMessages.uploadButtonLabel',
    description:
      'Label for upload image button in Images block on JobInfo page',
    defaultMessage: 'Upload Image',
  },
  noJobImagesMessage: {
    id: 'JobInfoImagesMessages.noJobImagesMessage',
    description: 'No job images message on JobInfo page',
    defaultMessage:
      'To upload a job image, click the "Upload Image" button above',
  },
  uploadModalTitle: {
    id: 'JobInfoImagesMessages.uploadModalTitle',
    description: 'Title for upload job image modal on JobInfo page',
    defaultMessage: 'Upload Image',
  },
  deleteModalTitle: {
    id: 'JobInfoImagesMessages.deleteModalTitle',
    description: 'Title for confirm delete job image modal on JobInfo page',
    defaultMessage: 'Delete Image',
  },
  deleteModalMessage: {
    id: 'JobInfoImagesMessages.deleteModalText',
    description: 'Message for confirm delete job image modal on JobInfo page',
    defaultMessage: 'Are you sure you want to delete {imageName} image?',
  },
  dropZoneModalDescription: {
    id: 'JobInfoImagesMessages.dropZoneModalDescription',
    description: "Drag 'n' drop message in dropZone Modal",
    defaultMessage: "Drag 'n' drop some files here, or click to select files",
  },
})
